import React__default from 'react';
var Certificates = function Certificates() {
  return /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__certificates-wrap"
  }, /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__certificates-image"
  }, /* @__PURE__ */React__default.createElement("img", {
    src: "https://static.iq360.com.br/images/certificates/ssl.svg",
    alt: "SSL Blindado",
    loading: "lazy",
    width: "74px",
    height: "53px"
  })), /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__certificates-image"
  }, /* @__PURE__ */React__default.createElement("img", {
    src: "https://static.iq360.com.br/images/certificates/reclame-aqui.svg",
    alt: "\xD3timo Reclame Aqui!",
    loading: "lazy",
    width: "59px",
    height: "60px"
  })), /* @__PURE__ */React__default.createElement("div", {
    className: "footer-cp__certificates-image"
  }, /* @__PURE__ */React__default.createElement("img", {
    src: "https://static.iq360.com.br/images/certificates/pci.svg",
    alt: "PCI",
    loading: "lazy",
    width: "84px",
    height: "36px"
  })));
};
export { Certificates as default };